import React, { useEffect, useState } from "react";

import LoadingSpinner from "component/loading";
import NotFound from "component/not-found";
import BaseTableRekapitulasi from "pages/scores/tabContent/tabContentLedger/BaseTableRekapitulasi";
import { useBaseContext } from "context/base";

export default function Rekapitulasi({ ta_tahun_code, total_semester }) {
  /* ====================================== Consume Context ===================================== */
  const { getRequest } = useBaseContext()

  const [isLoading, setIsLoading] = useState(false)

  const [data, setData] = useState([])
  const [listMapel, setListMapel] = useState([])

  const getData = async () => {
    setIsLoading(true)

    try {
      const response = await getRequest(
        `ledger-rekap?ta_tahun_code=${ta_tahun_code}`,
      )
      if (response) {
        const data = response?.data
        const mapel = response?.mapel

        if (Array.isArray(data) && !!data.length) {
          setData(data)
        }

        if (Array.isArray(mapel) && !!mapel.length) {
          const getListMapelName = mapel.map(m => m?.title)
          setListMapel(getListMapelName)
        }
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (Array.isArray(data) && !data.length && ta_tahun_code) {
      getData()
    }
  }, [ta_tahun_code])

  return (
    <>
      {isLoading
      ?
      <LoadingSpinner />
      : !isLoading && Array.isArray(data) && !!data.length
      ?
      <BaseTableRekapitulasi data={data} listMapel={listMapel} total_semester={total_semester} />
      :
      <NotFound
        text="Data Tidak Ditemukan"
        icon="fas fa-question"
      />
      }
    </>
  )
}